import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiLinkOff } from "@mdi/js";
import ConfirmationModal from "app/components/common/ConfirmationModal";
import "./changeSenderModal.css";

const ChangeSenderModal = ({
  show,
  onHide,
  senders,
  currentPreferredId,
  onConfirm,
  isLoading,
}) => {
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState(currentPreferredId);

  useEffect(() => {
    if (show) {
      setSelectedId(currentPreferredId);
    }
  }, [show, currentPreferredId]);

  const nonVirtualSenders = (senders || []).filter(
    (s) => s.provider_type !== "virtual"
  );

  const handleConfirm = () => {
    if (selectedId) {
      onConfirm(selectedId);
    }
  };

  const handleErrorIconClick = () => {
    onHide();
    navigate("/user-info", {
      state: { scrollTo: "calendar-connection" },
    });
  };

  return (
    <ConfirmationModal
      show={show}
      onHide={onHide}
      onConfirm={handleConfirm}
      title="Change Sender"
      confirmLabel="Confirm"
      confirmVariant="primary"
      isLoading={isLoading}
    >
      <p className="change-sender-description">
        Select which email address to send automated emails from.
      </p>
      <div className="sender-options">
        {nonVirtualSenders.map((sender) => {
          const isDisconnected = !sender.connected;
          return (
            <div
              key={sender.id}
              className={`sender-option ${isDisconnected ? "disconnected" : ""}`}
              onClick={() => setSelectedId(sender.id)}
            >
              <Form.Check
                type="radio"
                name="sender"
                checked={selectedId === sender.id}
                onChange={() => {}}
              />
              <div className="sender-option-details">
                <div className="sender-option-name-row">
                  <span className="sender-option-name">{sender.name}</span>
                  {isDisconnected && (
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip>Connection Error. Click to fix</Tooltip>
                      }
                    >
                      <button
                        type="button"
                        className="sender-option-error-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleErrorIconClick();
                        }}
                      >
                        <Icon path={mdiLinkOff} size={0.67} />
                      </button>
                    </OverlayTrigger>
                  )}
                </div>
                <span className="sender-option-email">{sender.email}</span>
              </div>
            </div>
          );
        })}
      </div>
    </ConfirmationModal>
  );
};

export default ChangeSenderModal;
